import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  projectAmenities: [],
  allProjectAmenities: []
};

export const ProjectAmenitiesSlice = createSlice({
  name: "projectAmenities",
  initialState,
  reducers: {
    getAllProjectAmenitiesAction: (state, action) => {
      state.allProjectAmenities = action.payload;
    },
    getSingleProjectAmenitiesAction: (state, action) => {
      
      state.projectAmenities = action.payload;
    },
  },
});

export default ProjectAmenitiesSlice.reducer;

export const { getAllProjectAmenitiesAction, getSingleProjectAmenitiesAction } = ProjectAmenitiesSlice.actions;
